import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Alert } from '@superdispatch/ui-lab';
import { SuperPayBankAccountDTO } from 'shared/modules/superpay/SuperPayDTO';
import styled from 'styled-components';

const DarkText = styled(Typography)`
  color: ${ColorDynamic.Dark500};
`;

interface Props {
  bankAccount?: SuperPayBankAccountDTO;
}

export function PaymentsInMotionAlert({ bankAccount }: Props) {
  const bankName = bankAccount?.bank_name;
  const displayNumber = bankAccount?.display_number;
  const hasBankReference = !!bankName && !!displayNumber;

  return (
    <Alert severity="info">
      <Stack space="xxsmall">
        <DarkText color="textSecondary" variant="h5">
          <b>Payments already in motion will land in the old bank account</b>
        </DarkText>
        <DarkText variant="body2">
          {hasBankReference ? (
            <>
              SuperPay payments initiated before you verify the new account will
              still settle to{' '}
              <b>
                {bankName} ••••{displayNumber}
              </b>
              . Future payments route to the new account once verification
              completes.
            </>
          ) : (
            <>
              SuperPay payments initiated before you verify the new account will
              still settle to your current bank account. Future payments route
              to the new account once verification completes.
            </>
          )}
        </DarkText>
      </Stack>
    </Alert>
  );
}
